import React from "react";
import { FlexBetween } from "../../../layout/FlexBetween/FlexBetween";
import { FlexCenter } from "../../../layout/FlexCenter/FlexCenter";
import { PanelLayout } from "../../../layout/Panel/Panel";
import { Spacing } from "../../../layout/Spacing/Spacing";
import IconComponent from "../../../shared/IconComponents/IconComponent";
import { CleanButton } from "../../../ui/CleanButton";
import { ExecButton } from "../../../ui/ExecButton/ExecButton";
import { TextCustom } from "../../../ui/TextCustom";
import { Title } from "../../../ui/Title";
import { removeFeature, removeProjectItem } from "../projectFeatureListFastUpdate.slice";
import { IFeature, IProjectConfig } from "../../../../interface/interfaces";
import { useAppDispatch } from "../../../../redux/hooks";
import { SpacingCustom } from "../../../layout/Spacing/SpacingCustom";
import { HideShowSection } from "../../../shared/HideShowSelections/HideShowSection";
import { ErrorNotification } from "../../../shared/ErrorNotification/ErrorNotification";
import { SeparatorLine } from "../../../shared/Separators/SeparatorLine";
import { Badge } from "../../../shared/Badge/Badge";
import { Button } from "../../../ui/Button";

interface IProjectAdminListItemCardProps {
    item: IProjectConfig,
    onEditItemOpenModalFunc: (item: IProjectConfig)=>void,
    onAddFeatureOpenModalFunc: (item: IProjectConfig)=>void
}

export const ProjectAdminListItemCard: React.FC<IProjectAdminListItemCardProps> = ({item, onEditItemOpenModalFunc, onAddFeatureOpenModalFunc}) => {
    const dispatch = useAppDispatch();


    const featureList = item.Features.map((feature:IFeature, idx: number) => {
        return (
            <div key={idx} style={{width: "100%"}}  className="animation-3" >
                <PanelLayout key={idx} animareOutline = {false} radius="m" hasShadow={false} borderIntensity={0} color="white">
                    <Spacing paddingSpacing="l" marginSpacing="none">
                        <FlexCenter direction="h" position="start" gap={1.5}>
                            <Badge label={feature.Tool} color="accent-blue" radius="s" fontSize={1.4}/>

                                {/* <Title color="dark" text={feature.Tool} size={"m"}/> */}
                            <FlexCenter direction="h" position="start" gap={0}>
                                <div style={{width:'100%', display:'grid', gridTemplateColumns: '150px 1fr', gap: '1rem'}}>
                                    <TextCustom weight={400} color="dark" size={1.2}>Feature name:</TextCustom>
                                    <TextCustom weight={500} color="dark" size={1.2}>{feature.FeatureName ? feature.FeatureName : '-'}</TextCustom>
                                </div>
                                <div style={{width:'100%', display:'grid', gridTemplateColumns: '150px 1fr', gap: '1rem'}}>
                                    <TextCustom weight={400} color="dark" size={1.2}>Default location:</TextCustom>
                                    <TextCustom weight={500} color="accent-green" size={1.2}>{feature.DefaultLocation ? feature.DefaultLocation : '-'}</TextCustom>
                                </div>
                                <div style={{width:'100%', display:'grid', gridTemplateColumns: '150px 1fr', gap: '1rem'}}>
                                    <TextCustom weight={400} color="dark" size={1.2}>Parameter:</TextCustom>
                                    <TextCustom weight={500} color="dark" size={1.2}>{feature.Parameter ? feature.Parameter : '-'}</TextCustom>
                                </div>
                                <div style={{width:'100%', display:'grid', gridTemplateColumns: '150px 1fr', gap: '1rem'}}>
                                    <TextCustom weight={400} color="dark" size={1.2}>Description:</TextCustom>
                                    <PanelLayout stretch color="white" hasShadow={false} borderIntensity={0} isRelative={false}>
                                        <TextCustom weight={500} color="grey-dark" size={1.2}>{feature.Description ? feature.Description : '-'}</TextCustom>
                                    </PanelLayout>
                                </div>
                            </FlexCenter>
                        </FlexCenter>
                        <FlexCenter direction="v" position="end" gap={0.5}>
                            <ExecButton size="m" showLabel = {false} label={"Modify"} func={() => console.log('Edit feature')} iconName={"Edit"}/>
                            <ExecButton size="m" showLabel = {false} label={"Delete"} func={() => dispatch(removeFeature({DepartmentId: item.DepartmentId, Tool: feature.Tool}))} iconName={"Delete"}/>
                        </FlexCenter>
                        {
                            idx !== item.Features.length - 1
                            &&
                            <SeparatorLine paddingTop={2}/>
                        }
                    </Spacing>
                </PanelLayout>
            </div>
        )
    })

  return (
    <>
        <PanelLayout animareOutline = {false} radius="m" hasShadow={false}>
            <Spacing paddingSpacing="l" marginSpacing="none">
                <FlexBetween>
                    <FlexCenter direction="h" position="start" gap={0.5}>
                        <FlexCenter direction="v" position="center" gap={0.5}>
                            <TextCustom weight={700} color="accent-green" size={1.2}>{item.DepartmentId}</TextCustom>
                            <Title text={item.Label} size={"l"}/>
                            <CleanButton func={() => onEditItemOpenModalFunc(item)}>
                                <IconComponent iconName={"Edit"} size={1.4}/>
                            </CleanButton>
                        </FlexCenter>
        
                    </FlexCenter>
                    <FlexCenter direction="v" position="center" gap={0.5}>
                        {/* <Button hasIcon iconName="Add_white" label={"Add feature"} role={"accent-blue"} size={"small"} func={()=>console.log('Add feature')}/> */}
                        {/* <Button label={"Delete"} role={"error"} size={"small"} func={()=>dispatch(removeProjectItem(item.DepartmentId))}/> */}
                            <ExecButton label={"Add feature"} iconName={"Add"} func={()=>onAddFeatureOpenModalFunc(item)}/>
                            <ExecButton showLabel = {true} label={"Delete department"} iconName={"Delete"} func={()=>dispatch(removeProjectItem(item.DepartmentId))}/>
                    </FlexCenter>
                </FlexBetween>
                <SpacingCustom paddingTop={1}>
                    {
                        featureList.length !== 0
                        ?
                        <HideShowSection setGap={1.5} color="white" label="Features" hasArrow={true} showTitle={false} arrowSize={1.6} defaultClose = {false} removeSpacing = {true}>
                            {featureList}
                        </HideShowSection>
                        :
                        <ErrorNotification text={"No features found. Please add it."} error={""} textSize={1.2} icon={<IconComponent size={2} iconName={"Warning"}/>}/>
                    }
                </SpacingCustom>
            </Spacing>
        </PanelLayout>
    </>
  )
}